import React, { useState, useEffect } from "react";

import api from '../../services/api.js';

import MyForm from "./Components/Form/MyForm.js";
import MyTable from "./Components/Table/MyTable.js";
import MyAppBar from "../MyAppBar/MyAppBar.js";

export default function NivelResp() {
    const [open, setOpen] = useState(false)
    const [data, setData] = useState(null)
    const [reload, setReload] = useState(false);


    const [list_funcoes, setListFuncoes] = useState([]);

    // buscando funções
    useEffect(() => {
        async function fetchData() {
            api.get(`/funcoes`)
                .then((res) => {
                    setListFuncoes(res.data)
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        fetchData();
    }, []);

    return (
        <>
            < MyAppBar />
            < MyTable reload={reload} setOpen={setOpen} setData={setData} setReload={setReload} />
            < MyForm data={data} open={open} setOpen={setOpen} setReload={setReload} list_funcoes={list_funcoes} />
        </>
    );
}
